<div *ngIf="!data.gradeGDConfirmation.hideConfirm && data.gradeGDConfirmation.numberOfStudent>0">
    <app-text [alias]="'instructor_grade_gd_confirmation'" [interpolationObject]="data.gradeGDConfirmation"></app-text>
</div>

<div *ngIf="!data.gradeIConfirmation.hideConfirm && data.gradeIConfirmation.numberOfStudent>0">
    <app-text [alias]="'instructor_grade_i_confirmation'" [interpolationObject]="data.gradeIConfirmation"></app-text>
</div>

<div *ngIf="!data.gradeChangeConfirmation.hideConfirm && data.gradeChangeConfirmation.numberOfStudent>0">
    <app-text [alias]="'instructor_grade_change_confirmation'" [interpolationObject]="data.gradeChangeConfirmation"></app-text>
</div>



<app-button-list>
    <app-button (clickedEvent)="onCancelClick()" [toolTip]="'cancel'">Cancel </app-button>
    <app-button (clickedEvent)="onSubmitClick()" [toolTip]="'check_circle'" >{{continueOrSubmitText}} </app-button>
</app-button-list>
